import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { LightArticle } from "@domain/lms/article/dtos";
import { formatTimeAgo } from "@utils/date";
import { desktop, mobile } from "@ui/styles/utils";
import { row, stack } from "@ui/components/layout";

interface ArticleCategoryAndDateProps extends React.HTMLAttributes<HTMLDivElement> {
	article: LightArticle;
}
export const ArticleCategoryAndDate: React.FC<ArticleCategoryAndDateProps> = ({ article, ...htmlProps }) => {
	const { subCategory, category, lastUpdateDate, publishedAt } = article;
	const currentProfile = useCurrentProfile();
	const currentLanguage = currentProfile?.language === "ENGLISH" ? "en" : "fr";
	return (
		<Container {...htmlProps}>
			<div>{`${I18n.t("article.infos.subcategory")} ${I18n.t(`category.${subCategory ?? category ?? "OTHERS"}`)}`}</div>
			<div>
				{publishedAt && (
					<div>
						{I18n.t("article.infos.date_published", { date: formatTimeAgo(publishedAt, false, currentLanguage) })}
					</div>
				)}
				{publishedAt?.toString() !== lastUpdateDate.toString() && (
					<div>{I18n.t("article.infos.date", { date: formatTimeAgo(lastUpdateDate, false, currentLanguage) })}</div>
				)}
			</div>
		</Container>
	);
};

const Container = styled.div`
	${({ theme }) => theme.textStyles.text};
	font-weight: 500;
	font-style: italic;
	display: flex;
	justify-content: space-between;
	@media ${desktop} {
		${row(10, "space-between")};
	}
	@media ${mobile} {
		${stack(10)};
	}
`;
